import { render } from "./CheckGreen.vue?vue&type=template&id=71dd3e22&ts=true"
import script from "./CheckGreen.vue?vue&type=script&lang=ts"
export * from "./CheckGreen.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__